import { container } from '../di/Container';
import { APP_CONFIG_TOKEN } from '../di/tokens';
import type { AppConfig } from '../di/types';

export function useTravelataAppConfig(): AppConfig {
  return container.resolve(APP_CONFIG_TOKEN);
}
